import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { PillButtonComponent } from "../pill-button/pill-button.component";

/**
 * A single dismissible notification card, as seen in the notifications dialog
 * (Figma file Tf9r7RZRYwDuXyDU0m1kGB, nodes 758:1247 / 758:1248 / 758:1266).
 * Presentational only — the parent supplies content, colors, and handles the
 * resulting events against DialogNotificationService.
 */
@Component({
  selector: "app-notification-card",
  templateUrl: "./notification-card.component.html",
  styleUrls: ["./notification-card.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule, PillButtonComponent],
})
export class NotificationCardComponent {
  @Input() illustrationSrc = "";
  @Input() illustrationAlt = "";
  /**
   * CSS custom property name (e.g. '--color-starlight') to render illustrationSrc as a
   * solid-color icon instead of the image as-authored. Needed for single-color SVG
   * icons (e.g. nav icons) - illustrationSrc renders via a plain <img>, which can't be
   * recolored with CSS the way an inline <svg-icon> can, so this uses a CSS mask
   * instead. Leave unset for the existing multi-color doodat illustrations (PNGs).
   */
  @Input() illustrationTintVar = "";
  /** Hides the illustration entirely (neither the <img> nor the tinted mask renders). */
  @Input() hideIllustration = false;
  @Input() title = "";
  @Input() body = "";
  /** Hides the body copy paragraph, keeping just the title. */
  @Input() hideCopy = false;
  /** CSS custom property name (e.g. '--color-sundown') used to tint the card background. */
  @Input() tintColorVar = "--color-parchment";
  @Input() ctaLabel = "";
  @Input() ctaGradientFrom = "";
  @Input() ctaGradientTo = "";
  @Input() ctaTextColor = "var(--color-evergreen)";

  @Output() dismissed = new EventEmitter<void>();
  @Output() ctaClicked = new EventEmitter<void>();

  get tintColor(): string {
    return `var(${this.tintColorVar})`;
  }
}
